module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Weight#2-b029a0ac8fd374a95864b8914ed71c55.svg";